import { render, staticRenderFns } from "./KeywordModalCard.vue?vue&type=template&id=57bfe9ce&scoped=true"
import script from "./KeywordModalCard.vue?vue&type=script&lang=js"
export * from "./KeywordModalCard.vue?vue&type=script&lang=js"
import style0 from "./KeywordModalCard.vue?vue&type=style&index=0&id=57bfe9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bfe9ce",
  null
  
)

export default component.exports